<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item date-item">
        <div class="date-grid">
          <label for="startDatePicker">Created At</label>
          <div class="date-search-container">
            <input
              type="date"
              v-model="formdate"
              class="search-input"
              :max="currentDate"
            />
            <button @click="performSearch" class="btn button-default">Search</button>
          </div>
        </div>
        <button
          type="button"
          class="btn button-default new-stock-allocation-btn mt-4"
          @click="newStockAllocation"
        >
          Create GRN
        </button>
      </div>

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr class="border-bottom-primary">
              <th scope="col">GRN Ref no</th>
              <th scope="col">PO Ref no</th>
              <th scope="col">Distributor</th>
              <th scope="col">GRN date</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order, index) in purchaseOrderList" :key="index">
              <td>{{ order.grn_reference_no }}</td>
              <td>{{ order.po_reference_no }}</td>
              <td>{{ order.business_name }}</td>
              <td>{{ order.created_at }}</td>
              <td class="mt-1">
                <span
                  :class="getStatusLabelClass(order.grn_status_label)"
                  v-html="getDispatchStatus(order.grn_status_label)"
                ></span>
              </td>
              <td>
              <!-- <i
                  v-if="order.grn_status_label === 'Partial'"
                  class="fa fa-edit"
                  aria-hidden="true"
                  @click="editDetails(order.id)"
                ></i> -->
                <i
                  class="fa fa-eye action-icon"
                  aria-hidden="true"
                  @click="showPopupModal(order)"
                ></i>
              </td>
            </tr>
            <tr v-if="!purchaseOrderList.length">
              <td colspan="5" class="text-center">No data available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="showPopup" class="modal">
  <div class="popup-content">
    <div class="popup-header">
      <h3>GRN Information</h3>
      <button @click="closePopup" class="close-btn">&times;</button>
    </div>

    <div v-if="loadingPopup" class="loading-spinner">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>
    <div v-else>
      <div>
        <p><strong>Reference No:</strong> {{ grnDetails.grn.reference_no }}</p>
        <p><strong>SAP Code:</strong> {{ grnDetails.grn.sap_code }}</p>
        <p><strong>Business Name:</strong> {{ grnDetails.grn.business_name }}</p>
        <p><strong>Received Date:</strong> {{ grnDetails.grn.received_date }}</p>
        <p><strong>Remarks:</strong> {{ grnDetails.grn.remarks }}</p>
        <p><strong>Total Value:</strong> {{ grnDetails.grn.total_value }}</p>
      </div>

      <div>
        <h4>GRN Items</h4>
        <table class="table">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Item Code</th>
              <th>Quantity</th>
              <th>Cost Price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in grnDetails.grn_details" :key="index">
              <td>{{ item.item_name }}</td>
              <td>{{ item.item_code }}</td>
              <td>{{ item.qty }}</td>
              <td>{{ item.cost_price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

  </div>
</template>

  
<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted, computed } from "vue";
import { fetchGrnList, fetchGrnDetailsPopup } from "@/services/dataService";

const router = useRouter();
const purchaseOrderList = ref([]);
const token = ref(localStorage.getItem("token_set") || "");
const formdate = ref("");
const loading = ref(false);
const showPopup = ref(false);
const loadingPopup = ref(false);

const newStockAllocation = () => {
  router.push({ path: "/grn-request" });
};

const getDispatchStatus = (status) => {
  if (status === "Completed") {
    return '<span class="status-completed">Completed</span>';
  } else if (status === "Partial") {
    return '<span class="status-pending">Partial</span>';
  } else if (status === "Rejected") {
    return '<span class="status-rejected">Rejected</span>';
  } else if (status === "Scheduled") {
    return '<span class="status-scheduled">Scheduled</span>';
  }
  return '<span class="status-unknown">Unknown</span>';
};

const getStatusLabelClass = (status) => {
  if (status === 'Completed') {
    return 'status-completed';
  } else if (status === 'Partial') {
    return 'status-pending';
  } else if (status === 'Rejected') {
    return 'status-rejected';
  } else if (status === 'Scheduled') {
    return 'status-scheduled';
  }
  return 'status-unknown';
};

const loadPurchaseOrderList = async () => {
  try {
    const profileId = localStorage.getItem("profile_id");
    const token = localStorage.getItem("token_set");
    loading.value = true;
    const payload = {
      created_by: profileId,
      formdate: formdate.value,
    };

    const response = await fetchGrnList(token, payload);

    if (response.data.status === "success") {
      purchaseOrderList.value = response.data.data;
    } else {
      console.log(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching purchase order list:", error);
  } finally {
    loading.value = false;
  }
};

const performSearch = async () => {
  loading.value = true;
  purchaseOrderList.value = []; // Clear existing data while searching
  try {
    const profileId = localStorage.getItem("profile_id");
    const payload = {
      created_by: profileId,
      formdate: formdate.value,
    };

    const response = await fetchGrnList(token.value, payload);

    if (response.data.status === "success") {
      const results = response.data.data;
      if (results.length) {
        purchaseOrderList.value = results;
      } else {
        purchaseOrderList.value = [];
        console.log("No data found for the selected date.");
      }
    } else {
      console.log(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching purchase order list:", error);
  } finally {
    loading.value = false;
  }
};

const editDetails = (id) => {
  router.push({ path: `/edit-grn/${id}` });
};

const grnDetails = ref({ grn: {}, grn_details: [] });

const showPopupModal = async (order) => {
  try {
    loadingPopup.value = true;
    showPopup.value = true;

    const response = await fetchGrnDetailsPopup(order.id, token.value);

    if (response.data.status === "success") {
      grnDetails.value = response.data.data;
    } else {
      console.error("Error fetching GRN details:", response.data.message);
    }
  } catch (error) {
    console.error("Error in showPopupModal:", error);
  } finally {
    loadingPopup.value = false;
  }
};

const closePopup = () => {
  showPopup.value = false;
};

const currentDate = computed(() => {
  const date = new Date();
  return date.toISOString().split("T")[0];
});

onMounted(async () => {
  formdate.value = currentDate.value;
  await loadPurchaseOrderList();
});
</script>

  
  
  <style scoped lang="scss">
  .loading-spinner {
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
    color: #007bff;
  }
  
  .search-input[type="date"] {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px;
    transition: border-color 0.3s, box-shadow 0.3s;
    width: 100%;
  }
  
  .search-input[type="date"]:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
    outline: none;
  }
  
  .search-input[type="date"]:hover {
    border-color: #0056b3;
  }
  
  .date-grid {
    display: grid;
    grid-template-rows: auto auto;
    gap: 5px;
    font-weight: bold;
  }
  
  .date-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  
  .date-search-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .date-search-container .search-input {
    flex: 1;
    margin-right: 10px;
  }
  
  .fa-eye {
    cursor: pointer;
    transition: color 0.3s, transform 0.3s;
    margin-left: 5px;
  }
  
  .fa-eye:hover {
    color: #0056b3;
    transform: scale(1.2);
  }
  
  .fa-eye:active {
    transform: scale(1.1);
  }
  
  .fa-edit {
    cursor: pointer;
    transition: color 0.3s, transform 0.3s;
  }
  
  .fa-edit:hover {
    color: #0056b3;
    transform: scale(1.2);
  }
  
  .fa-edit:active {
    transform: scale(1.1);
  }
  
  .action-icon {
    margin-right: 10px;
  }
  
  .new-stock-allocation-btn {
    margin-left: auto;
    padding: 10px 20px;
  }
  
  .status-pending {
    background-color: #FFC107; /* Yellow color */
    color: #FFFFFF; /* White text */
    padding: 5px 10px;
    border-radius: 5px;
  }
  
  .status-rejected {
    background-color: red; /* Red color */
    color: #FFFFFF; /* White text */
    padding: 5px 10px;
    border-radius: 5px;
  }
  
  .status-scheduled {
    background-color: #1B6CB4; /* Blue color */
    color: #FFFFFF; /* White text */
    padding: 5px 10px;
    border-radius: 5px;
  }
  
  .status-completed {
    background-color: #069E27; /* Green color */
    color: #FFFFFF; /* White text */
    padding: 5px 10px;
    border-radius: 5px;
  }
  
  .status-unknown {
    background-color: grey; /* Grey color */
    color: #FFFFFF; /* White text */
    padding: 5px 10px;
    border-radius: 5px;
  }
  
  .status-label {
    padding: 5px 10px;
    border-radius: 3px;
    display: inline-block;
  }
  
  
  /* Popup modal */
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .popup-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    width: 800px;
    max-width: 100%;
    max-height: 80vh; /* Set a maximum height */
    overflow-y: auto; /* Enable vertical scrolling */
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
  
  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #000;
    transition: color 0.3s;
  }
  
  .popup-content h3 {
    margin-top: 0;
  }
  
  .popup-content ul {
    padding-left: 20px;
  }
  
  .popup-content ul li {
    margin-bottom: 10px;
  }
  
  .popup-table {
    max-height: 300px; /* Adjust the height as needed */
    overflow-y: auto;  /* Enable vertical scrolling */
  }
  </style>